module.exports = __webpack_public_path__ + "img/sixth_tree.ad1fe56b.png";